import { render } from "./UserReport.vue?vue&type=template&id=743039fc&ts=true"
import script from "./UserReport.vue?vue&type=script&lang=ts"
export * from "./UserReport.vue?vue&type=script&lang=ts"

import "./UserReport.vue?vue&type=style&index=0&id=743039fc&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__